/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Chargeback,
    ChargebackFromJSON,
    ChargebackFromJSONTyped,
    ChargebackToJSON,
    Page,
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './';

/**
 * 
 * @export
 * @interface ListChargebacksResponse
 */
export interface ListChargebacksResponse {
    /**
     * 
     * @type {Page}
     * @memberof ListChargebacksResponse
     */
    paging?: Page;
    /**
     * 
     * @type {Array<Chargeback>}
     * @memberof ListChargebacksResponse
     */
    data?: Array<Chargeback>;
}

export function ListChargebacksResponseFromJSON(json: any): ListChargebacksResponse {
    return ListChargebacksResponseFromJSONTyped(json, false);
}

export function ListChargebacksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListChargebacksResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paging': !exists(json, 'paging') ? undefined : PageFromJSON(json['paging']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ChargebackFromJSON)),
    };
}

export function ListChargebacksResponseToJSON(value?: ListChargebacksResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paging': PageToJSON(value.paging),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ChargebackToJSON)),
    };
}


